import type { CollectionCategory, PersistedGameState } from '../../../core/domain/types';

export interface CollectionReward {
  coins: number;
  xp: number;
}

export interface CollectionProgress {
  discovered: number;
  total: number;
  complete: boolean;
  claimed: boolean;
}

export const COLLECTION_REWARDS: Record<CollectionCategory, CollectionReward> = {
  crop: { coins: 300, xp: 80 },
  furniture: { coins: 800, xp: 150 },
  clothing: { coins: 800, xp: 150 },
  house: { coins: 500, xp: 120 },
};

export const HOUSE_LEVEL_IDS = Array.from(
  { length: 5 },
  (_, index) => 'house_level_' + (index + 1),
);

export function discoveredCollectionIds(
  game: PersistedGameState,
  category: CollectionCategory,
): string[] {
  if (category === 'crop') return game.collection.discoveredCropIds;
  if (category === 'furniture') return game.collection.discoveredFurnitureIds;
  if (category === 'clothing') return game.collection.discoveredClothingIds;
  return HOUSE_LEVEL_IDS.slice(0, game.home.houseLevel);
}

export function collectionProgress(
  game: PersistedGameState,
  category: CollectionCategory,
  catalogIds: string[],
): CollectionProgress {
  const discoveredIds = new Set(discoveredCollectionIds(game, category));
  const discovered = catalogIds.filter((id) => discoveredIds.has(id)).length;
  const total = catalogIds.length;
  return {
    discovered,
    total,
    complete: total > 0 && discovered === total,
    claimed: game.collection.claimedCategoryRewardIds.includes(category),
  };
}

export function isNewCollectionItem(game: PersistedGameState, itemId: string): boolean {
  return !game.collection.seenIds.includes(itemId);
}
